import { ChangeEvent, forwardRef } from "react";
import { Controller, FieldError, RegisterOptions, useFormContext } from "react-hook-form";
import { StyledInput } from "../form/FormElementStyles";
import { Container, StyledFormLabel } from "./CommonStyles";

export interface TextFieldProps {
    label: string;
    id: string;
    description?: string;
    placeholder?: string;
    defaultValue?: string;
    error?: FieldError;
    errorMessage?: string;
    required?: boolean;
    type?: string;
    onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
    additionalInfo?: string;
    fontWeightBold?: boolean;
    registerOptions?: RegisterOptions;
    inline?: boolean;
    readonly?: boolean;
    className?: string;
}

/**
 * text input field for edit entry form
 */
export const TextField = forwardRef<any, TextFieldProps>((props: TextFieldProps, ref) => {
    const {
        label,
        id,
        placeholder,
        required,
        type = "text",
        description,
        defaultValue,
        additionalInfo,
        fontWeightBold,
        registerOptions,
        inline = false,
        readonly = false,
        className,
    } = props;

    const {
        control,
        register,
        formState: { errors },
    } = useFormContext();

    return (
        <Container inline={inline} className={className}>
            <StyledFormLabel
                htmlFor={id}
                required={required}
                text={label}
                description={description}
                additionalInfo={additionalInfo}
                fontWeightBold={fontWeightBold}
            />
            <div>
                <Controller
                    control={control}
                    name={id}
                    defaultValue={defaultValue ?? ""}
                    rules={{ required: required, ...(registerOptions || {}) }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                        <StyledInput
                            id={id}
                            inputRef={ref}
                            value={value}
                            error={!!errors[id]}
                            type={type}
                            aria-invalid={errors[id] ? "true" : "false"}
                            placeholder={placeholder}
                            required={required}
                            onChange={onChange}
                            onBlur={onBlur}
                            readOnly={readonly}
                        />
                    )}
                />
            </div>
        </Container>
    );
});
